export const environment = {
  production: true,
  stepchangeUrl: 'https://www.stepchange.org'
};
